<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPrestador" class="form-label">IdPrestador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPrestador" name="idPrestador" v-model="datoPrestador.idPrestador" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="razonSocial" class="form-label">RazonSocial</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="razonSocial" name="razonSocial" v-model="datoPrestador.razonSocial" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreComercial" class="form-label">NombreComercial</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombreComercial" name="nombreComercial" v-model="datoPrestador.nombreComercial" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="ruc" class="form-label">Ruc</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="ruc" name="ruc" v-model="datoPrestador.ruc" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPrestador.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoPrestador.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarPrestador" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPrestador" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdTarifaPres</th>
          <th scope="col">IdTarifa</th>
          <th scope="col">IdPrestador</th>
          <th scope="col">IdTarifaConv</th>
          <th scope="col">IdElemento</th>
          <th scope="col">Valor</th>
          <th scope="col">Estado</th>
          <th scope="col">ElementoNombre</th>
          <th scope="col">TarifaConvNombre</th>
          <th scope="col">PrestadorFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tarifapres in datosPaginados" :key="tarifapres.idTarifaPres">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tarifapres.idTarifaPres)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tarifapres.idTarifaPres)" title="Editar">edit_square</i></td>
          <td>{{tarifapres.idTarifaPres}}</td>
          <td>{{tarifapres.idTarifa}}</td>
          <td>{{tarifapres.idPrestador}}</td>
          <td>{{tarifapres.idTarifaConv}}</td>
          <td>{{tarifapres.idElemento}}</td>
          <td>{{tarifapres.valor}}</td>
          <td>{{tarifapres.estado}}</td>
          <td>{{tarifapres.elementoNombre}}</td>
          <td>{{tarifapres.tarifaConvNombre}}</td>
          <td>{{getFormattedDate(tarifapres.prestadorFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePrestador(tarifapres.idTarifaPres)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifaPres" class="form-label">IdTarifaPres</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifaPres" name="idTarifaPres" v-model="datoTarifaPres.idTarifaPres" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idTarifa" class="form-label"> Tarifa</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTarifa" name="idTarifa" v-model="datoTarifaPres.idTarifa">
                      <option v-for="tarifa in tarifas" :value="tarifa.idTarifa" :key="tarifa.idTarifa">
                        {{ tarifa.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPrestador" class="form-label">IdPrestador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPrestador" name="idPrestador" v-model="datoTarifaPres.idPrestador" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idTarifaConv" class="form-label"> Tarifa Conv</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTarifaConv" name="idTarifaConv" v-model="datoTarifaPres.idTarifaConv">
                      <option v-for="tarifaConv in tarifaConvs" :value="tarifaConv.idTarifaConv" :key="tarifaConv.idTarifaConv">
                        {{ tarifaConv.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoTarifaPres.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="valor" class="form-label">Valor</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="valor" name="valor" v-model="datoTarifaPres.valor" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTarifaPres" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTarifaPres" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat from '../../modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      prestadors : [],
      datoPrestador : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idPrestador: '',
// Variables master
// Variables details
      tarifapress : [],
      datoTarifaPres : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      tarifas : [],
      tarifaConvs : [],
      elementos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idPrestador = this.$route.params.p_idprestador
    this.abrirEditar(this.p_idPrestador)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'razonSocial'
        ,'nombreComercial'
        ,'ruc'
      ];
      const requiredFieldsText = [
        'razonSocial'
        ,'nombreComercial'
        ,'ruc'
      ];
      return validarForm(this.datoPrestador, requiredFields, requiredFieldsText);
    },
    async guardarPrestador(){
      if(this.validarForm() === 1){
        try {
          await api.post('/prestadors', this.datoPrestador)
          swal("Correcto!", "Prestador creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPrestador(){
      if(this.validarForm() === 1){
        try {
          await api.post('/prestadors', this.datoPrestador)
          swal("Correcto!", "Prestador creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoPrestador={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idPrestador){
      this.modalWindow = true
      if(idPrestador != null){    
           api.get('/vwprestadors/'+idPrestador).then(resp=>{
          this.datoPrestador = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPrestador(){
      this.$router.push('/Prestador')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.tarifapress.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwtarifapress/nombre/'+this.nombreBusqueda).then(response=>{
          this.tarifapress=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.tarifapress.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwtarifapress').then(response=>{
      this.tarifapress=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tarifapress.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'razonSocial'
        ,'nombreComercial'
        ,'ruc'
      ];
      const requiredFieldsText = [
        'razonSocial'
        ,'nombreComercial'
        ,'ruc'
      ];
      return validarForm(this.datoPrestador, requiredFields, requiredFieldsText);
    },
    async guardarTarifaPres(){
      if(this.validarForm() === 1){
        try {
          this.datoTarifaPres.idPrestador = this.datoPrestador.idPrestador;
          await api.post('/tarifapress', this.datoTarifaPres)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "TarifaPres creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTarifaPres(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifapress', this.datoTarifaPres)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "TarifaPres creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTarifaPres={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idTarifaPres){
      this.modalWindow = true
      if(idTarifaPres != null){    
           api.get('/vwtarifapress/'+idTarifaPres).then(resp=>{
          this.datoTarifaPres = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idTarifaPres){
      this.modalWindow = true
      if(idTarifaPres != null){
        this.$router.push('/tarifapresmd/'+idTarifaPres)
      }
    },
    async deleteTarifaPres (idTarifaPres) {
      try{
        await api.delete('/tarifapress/'+idTarifaPres)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchTarifas() {
      fetch('http://localhost:8080/api/v1/tarifas')
        .then(response => response.json())
        .then(data => {
          this.tarifas = data;
        })
        .catch(error => {
          console.error('Error fetching tarifas:', error);
        });
    },
    fetchPrestadors() {
      fetch('http://localhost:8080/api/v1/prestadors')
        .then(response => response.json())
        .then(data => {
          this.prestadors = data;
        })
        .catch(error => {
          console.error('Error fetching prestadors:', error);
        });
    },
    fetchTarifaConvs() {
      fetch('http://localhost:8080/api/v1/tarifaconvs')
        .then(response => response.json())
        .then(data => {
          this.tarifaConvs = data;
        })
        .catch(error => {
          console.error('Error fetching tarifaConvs:', error);
        });
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
  },
}
</script>
